import querystring from "query-string";

import { isServerSide } from "@jti/fe-common";

export const useWindowSearchQuery = () => {
  if (isServerSide()) {
    return {};
  }

  return querystring.parse(window.location.search);
};
